import React, { useState } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import { ListedReportMail } from 'helper/mailer';
import { ListedCompany } from 'helper/companies';
import RecipientCompanyTable from 'components/Admin/Mailer/ReportsTable/RecipientCompanyTable';
import { cssVar } from 'constants/theme';

import './index.scss';

// Mesma semântica de status do LabelIcon do desktop: cada etapa do relatório
// (Word, PDF, e-mail, finalizado) acende verde quando concluída.
const STATUS_STEPS: { type: string, icon: IconType, label: string }[] = [
  { type: 'ckWordGenerated', icon: 'word', label: 'Word' },
  { type: 'ckPdfGenerated', icon: 'pdf', label: 'PDF' },
  { type: 'ckMailGenerated', icon: 'message', label: 'E-mail' },
  { type: 'ckFinalized', icon: 'checkmark', label: 'Finalizado' },
];

const ACTIVE_COLOR = cssVar('success-solid');
const INACTIVE_COLOR = cssVar('text-disabled');

export default function ReportCard({ report, companies }: {
  report: ListedReportMail,
  companies: ListedCompany[],
}) {
  const [expanded, setExpanded] = useState(false);
  const {
    id, processId, type, fileName, dtRequest, status,
  } = report;

  return (
    <div className="report-card">
      <div className="report-card-body">
        <h3 className="report-card-title">{fileName}</h3>
        <p className="report-card-id">{processId}</p>
        <dl className="report-card-meta">
          <div>
            <dt>Produto</dt>
            <dd>{type}</dd>
          </div>
          <div>
            <dt>Data/hora</dt>
            <dd>{dtRequest}</dd>
          </div>
        </dl>
        <div className="report-card-status">
          {STATUS_STEPS.map((step) => {
            const active = Boolean(status[0]?.[step.type]);
            return (
              <span
                key={step.type}
                className="report-card-status-item"
                aria-label={`${step.label}: ${active ? 'concluído' : 'pendente'}`}
              >
                <Icon
                  id={`${step.icon}-generated-${processId}`}
                  iconType={step.icon}
                  color={active ? ACTIVE_COLOR : INACTIVE_COLOR}
                  size="large"
                />
              </span>
            );
          })}
        </div>
        <button
          type="button"
          className="report-card-toggle"
          aria-expanded={expanded}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Ocultar destinatários' : 'Ver destinatários'}
          <Icon iconType={expanded ? 'up_arrow' : 'down_arrow'} color={cssVar('text-secondary')} size="small" />
        </button>
        {expanded && (
          <div className="report-card-recipients">
            <RecipientCompanyTable reportMailId={id} companies={companies} />
          </div>
        )}
      </div>
    </div>
  );
}
